import { render, staticRenderFns } from "./BasicOverview.vue?vue&type=template&id=25b07dc4"
import script from "./BasicOverview.vue?vue&type=script&lang=js"
export * from "./BasicOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports